module.exports = __webpack_public_path__ + "static/media/ic_upload_disabled.d7a2f99e.svg";